/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {EEmbededElementTypes, RenderDocument} from "js_renderer";
import Element from "../element";
import {vec3} from "gl-matrix";

export default
class GeometryEntity extends Element {
    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        // default properties
        this.extendProperties({
            pickable: true,
            baseColor: vec3.fromValues(1.0, 1.0, 1.0)
        });
    }

    public extendProperties(aProperties: any) {
        // extend the properties
        super.extendProperties(aProperties);

        if (this._properties.baseColor !== undefined && aProperties.baseColor !== undefined) {
            this._properties.baseColor = vec3.clone(aProperties.baseColor);
        }
    }

    public getTitle(): string {
        return this._properties.title;
    }

    public getDescription(): string {
        return this._properties.description;
    }

    public getColor(): vec3 {
        return vec3.clone(this._properties.baseColor);
    }

    /***
     * This returns user specified url during export which can be e.g. opened when user click on this geometry entity.
     *
     * @returns {*}
     */
    public getUrl(): string {
        return this._properties.url;
    }
}
